<script>
import SaleItemGridHeader from "./sale-item-grid-header.vue";
import SaleItemRow from "./sale-item-row.vue";
import SaleItemTripSummary from "./sale-item-trip-summary.vue";

export default {
  components: {
    SaleItemGridHeader,
    SaleItemRow,
    SaleItemTripSummary,
  },
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      quality_options: [
        {value: "fresh", text: "Fresh"},
        {value: "km", text: "Kulit Muda (KM)"},
        {value: "bs", text: "Below Standard (BS)"},
        {value: "us", text: "Under Size (US)"},
        {value: "merah", text: "Merah"},
      ],
    };
  },
  computed: {
    visibleItems() {
      return (this.value || [])
        .map((item, index) => ({ item, index }))
        .filter(({ item }) => item?._action !== "delete");
    },
    disableMergeButton() {
      return this.visibleItems.filter(({ item }) => item.selected_checkbox).length < 2;
    },
    displayNumbers() {
      let counter = 0;
      return this.visibleItems.map(({ item }) => {
        if (item.trip_item_relation_type !== "partial" || item.is_first_partial_item) {
          counter += 1;
          return counter;
        }
        return null;
      });
    },
  },
  methods: {
    onChangeCheckbox(index) {
      this.$emit("change-checkbox", this.value[index]);
    },
    onClickUngroupItem(index) {
      this.$emit("ungroup-item", index);
    },
    onClickPartialItem(index) {
      this.$emit("partial-item", index);
    },
    onClickMergeItem() {
      const selectedIndexes = this.visibleItems
        .filter(({ item }) => item.selected_checkbox)
        .map(({ index }) => index);
      this.$emit("merge-item", selectedIndexes);
    },
    mergeTripItems(item) {
      return (item.trip_items || [])
        .map((tripItem, tripItemIndex) => ({tripItem, tripItemIndex}))
        .filter(({tripItemIndex}) => tripItemIndex !== 0);
    },
    rowSpanFor(item) {
      if (item.trip_item_relation_type === "merge") {
        const tripItems = item.trip_items || [];
        const count = tripItems.length;
        return Math.max(1, 2 * count - 1);
      }
      if (item.trip_item_relation_type === "partial" && item.is_first_partial_item) {
        return Math.max(1, item.partial_item_length || 1);
      }
      return 1;
    },
    onRemovePartialItem(index) {
      this.$emit("remove-partial-item", index);
    },
  },
};
</script>

<template>
  <div>
    <div class="d-flex justify-content-between">
      <span class="section-header">{{ lodash.startCase($t("unload_items.singular")) }}</span>
      <b-button style="font-weight: 600" variant="primary" @click="onClickMergeItem" :disabled="disableMergeButton">
        {{ lodash.startCase(`${$t("buttons.merge")} ${$t('unload_items.singular')}`) }}
      </b-button>
    </div>
    <div class="grid-table-wrapper">
      <div class="sale-grid">
        <template v-for="({ item, index }, displayIndex) in visibleItems">
          <sale-item-grid-header v-if="displayNumbers[displayIndex] === 1" :key="`header-${index}`" :item="item" />
          <sale-item-row
            :key="`row-${index}`"
            :item="item"
            :index="index"
            :quality-options="quality_options"
            :row-span="rowSpanFor(item)"
            :show-partial-button="item.show_partial_button"
            :show-ungroup-button="item.trip_item_relation_type === 'merge'"
            :display-number="displayNumbers[displayIndex]"
            :validation-key="index"
            @change-checkbox="onChangeCheckbox"
            @partial-item="onClickPartialItem"
            @remove-partial-item="onRemovePartialItem"
            @ungroup-item="onClickUngroupItem"
          />
          <template v-if="item.trip_item_relation_type === 'merge'">
            <sale-item-trip-summary
              v-for="mergeRow in mergeTripItems(item)"
              :key="`merge-trip-${index}-${mergeRow.tripItemIndex}`"
              :trip-item="mergeRow.tripItem"
              :trip-item-index="mergeRow.tripItemIndex"
            />
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
::v-deep {
  .grid-table-wrapper {
    overflow-x: auto;
  }

  .sale-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(50px, 50px)) repeat(5, 100px) repeat(2, 125px) repeat(3, minmax(125px, 175px));
    grid-template-rows: 20px 1fr;
    width: max-content;
    min-width: 100%;
  }

  .sale-row {
    display: contents;
  }

  .cell {
    display: flex;
    align-items: flex-start;
    padding: 0 14px;
    white-space: nowrap;
    background: #fff;
  }

  .sale-header-main .cell {
    font-weight: 600;
    justify-content: center;
  }

  .sale-header-sub .cell {
    font-weight: 600;
  }

  .header-sticky {
    z-index: 3;
  }

  .header-group {
    text-align: center;
    font: 13px/20px 600 Inter !important;
    color: black;
  }

  .cell-sticky {
    position: sticky;
    z-index: 2;
  }

  .cell-sticky-first {
    left: 0;
  }

  .cell-sticky-second {
    left: 50px;
  }

  .cell-border-left {
    border-left: 1px solid #D9D9D9;
  }
  .cell-border-right {
    border-right: 1px solid #D9D9D9;
  }
}
.section-header {
  color: #6C7589;
  font: 600 13px/20px Inter !important;
}
</style>
